import React, { useState } from 'react'
import AmountModal from './modals/AmountModal';
import TopNav from './TopNav'
import { parsePrice } from '../tools/extentions'
import  { Redirect } from 'react-router-dom'
import sia from "../services/Api";

function Donate(params) {

    const [isShowingAmountModal, setIsShowingAmountModal] = useState(false)
    const [amount, setAmount] = useState(20000)
    const [selectedIndex, setSelectedIndex] = useState(0)
    const handleClick = (id) => {
        setSelectedIndex(id)
        switch (id) {
            case 0:
                setAmount(20000)
                return;
            case 1:
                setAmount(50000)
                return
            case 2:
                setAmount(100000)
                return
            case 3:
                setAmount(200000)
                return
            case 4:
                setAmount(500000)
                return
        }
    };
    return (
        <div>
            {isShowingAmountModal && <AmountModal onCloseFunc={() => setIsShowingAmountModal(false)} title="انتخاب مبلغ" message="مبلغ مورد نظر را در کادر زیر وارد نمایید :" onSelect={(a) => {
                setAmount(a)
                setIsShowingAmountModal(false)
            }} />}
            <meta httpEquiv="content-type" content="text/html; charset=utf-8" />
            <title>نکویاد</title>
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            <link rel="stylesheet" type="text/css" href="assets/css/fonts.css" media="all" />
            <link rel="stylesheet" type="text/css" href="assets/css/styles.css" media="all" />
            <header>
                <div className="pagewrapper slim2" id="header-slim">
                    <div className="container">
                        <TopNav />
                    </div>
                </div>
            </header>
            <div className="clear" />
            <div className="pagewrapper" id="donate">
                <div className="container">
                    <h1 className="main-title">حمایت مالی از نکویاد</h1>
                    <p style={{marginTop: '20px', marginBottom: '25px', fontSize: '18px'}}>با سلام ودرود
                        نکویاد با هدف خلق اثری ماندگار در زمینه کسب و کارهای آنلاین در خصوص برگزاری مجالس ختم
                        آنلاین، ختم دوره و صلوات و نیز دیدبانی هوشمند جهت حمایت از نیازمندان و محرومین می باشد. از
                        آن جهت که کلیه خدمات در این بستر رایگان می باشد در صورت صلاحدید می توانید این سامانه را در
                        راستای ارتقای کیفیت همراهی نموده و از ما حمایت نمایید. پیشاپیش از شما کمال تشکر و قدردانی را
                        داریم .</p>
                    <a onClick={() => handleClick(0)} title className={"link-button ease box-sizing radius50 " + (selectedIndex == 0 && 'Green-background')}>20.000 تومان</a>
                    <a onClick={() => handleClick(1)} title className={"link-button ease box-sizing radius50 " + (selectedIndex == 1 && 'Green-background')}>50.000 تومان</a>
                    <a onClick={() => handleClick(2)} title className={"link-button ease box-sizing radius50 " + (selectedIndex == 2 && 'Green-background')}>100.000 تومان</a>
                    <a onClick={() => handleClick(3)} title className={"link-button ease box-sizing radius50 " + (selectedIndex == 3 && 'Green-background')}>200.000 تومان</a>
                    <a onClick={() => handleClick(4)} title className={"link-button ease box-sizing radius50 " + (selectedIndex == 4 && 'Green-background')}>500.000 تومان</a>
                    <a onClick={() => {
                        setSelectedIndex(5)
                        setIsShowingAmountModal(true)
                    }} title className={"link-button ease box-sizing radius50 " + (selectedIndex == 5 && 'Green-background')}>{amount ? 'دلخواه : ' + parsePrice(amount) : 'دلخواه'}</a>
                    <a href={'https://nekooyad.com/proc/pay/'+amount} title className="link-button blue ease box-sizing radius50">پرداخت</a>
                </div>
            </div>
            <div className="clear" />
            <footer>
                <div className="pagewrapper" id="footer">
                    <div className="container box-sizing">
                        <div className="copyright">
                            <a href="#" title><img src="assets/images/logo.svg" alt="" className="logo" width={57} height={57} /></a>
                            طراحی و توسعه و بهینه سازی توسط <a href="https://wwwebsite.ir/" title="وب سایت پارسی">وب سایت پارسی</a>
                        </div>
                        <a href title><img src="assets/images/enamad.png" alt="" width={89} height={89} className="certificate" /></a>
                        <a href title><img src="assets/images/samandehi.png" alt="" width={89} height={89} className="certificate" /></a>
                    </div>
                </div>
            </footer>
        </div>
    );
}

export default Donate
